import { Box, Group, Pagination } from "@mantine/core";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import {
    selectPreviewResult,
    selectReportPagination,
    executeReportDataThunk,
    selectReportFull
} from "@/store/slices/reportSlice";
import { useAuth } from "@bi-studio/shared/hooks";
import { useParams } from "react-router-dom";

export function ReportPagination() {
    const dispatch = useAppDispatch();
    const { token } = useAuth();
    const { id: reportId } = useParams<{ id: string }>();
    const previewResult = useAppSelector(selectPreviewResult);
    const { page, pageSize } = useAppSelector(selectReportPagination);
    const { variableValues } = useAppSelector(selectReportFull);

    if (!previewResult || (previewResult.rowCount || 0) <= pageSize) {
        return null;
    }

    const totalPages = Math.ceil((previewResult.rowCount || 0) / pageSize);

    const handlePageChange = (p: number) => {
        if (!token || !reportId) return;
        dispatch(executeReportDataThunk({
            token,
            reportId,
            variables: variableValues,
            cache: false,
            pagination: { page: p, pageSize }
        }));
    };

    return (
        <Box py={{ base: 'xs', sm: 'sm' }} px={{ base: 'xs', sm: 'md' }} style={{ borderTop: '1px solid var(--modal-border)' }}>
            <Group justify="center">
                <Pagination
                    total={totalPages}
                    value={page}
                    onChange={handlePageChange}
                    size="sm"
                />
            </Group>
        </Box>
    );
}
